export enum EDomainValue {
  DEFAULT = '',
  LITHUANIA = 'lt-travel',
  OTHER_COUNTRY = 'oc-travel',
}

export enum EDomainCountry {
  LITHUANIA = 'lithuania',
}

export enum EDomainCountryId {
  LITHUANIA = 31,
  OTHER_COUNTRY = 555,
}

export enum EDomainCurrency {
  LITHUANIA = 'EUR',
  OTHER_COUNTRY = 'USD',
}

export enum EDomainCurrencySymbol {
  LITHUANIA = '€',
  OTHER_COUNTRY = '$',
}
